import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Company } from '../../../forms/models';
import { FormViewService, CompanyService } from '@xilo-mono/form-contracts';
import { ReplaySubject, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
  companyDetails: Company;
  formViewMetadata;
  width = window.innerWidth;

  private readonly destroyed$ = new ReplaySubject<boolean>(1);
  @HostListener('window:resize', ['$event'])
  onResize(event: { target: { innerWidth: number } }) {
    this.width = event.target.innerWidth;
  }

  get logo() {
    return this.formViewMetadata?.customLogo || this.companyDetails?.logo;
  }

  get logoHeight() {
    return (
      this.formViewMetadata?.customLogoHeight || this.companyDetails?.logoHeight
    );
  }

  get logoUrl() {
    return (
      this.formViewMetadata?.customLogoUrl || this.companyDetails?.brandingURL
    );
  }

  get address() {
    if (this.formViewMetadata?.customContactInfo) {
      return this.formViewMetadata?.address;
    } else {
      return this.companyDetails?.mainLocation;
    }
  }

  get phoneNumber() {
    if (this.formViewMetadata?.customContactInfo) {
      return this.formViewMetadata?.phoneNumber;
    } else {
      return this.companyDetails?.contactNumber;
    }
  }

  get textNumber() {
    if (this.formViewMetadata?.customContactInfo) {
      return this.formViewMetadata?.textNumber;
    } else {
      return this.companyDetails?.textNumber;
    }
  }

  get isMobile() {
    return this.width <= 767;
  }

  get showBanner() {
    if (this.queryParams?.hideNav === 'true') {
      return false;
    } else if (typeof this.formViewMetadata?.showBanner !== 'undefined') {
      return this.formViewMetadata?.showBanner;
    } else {
      return true;
    }
  }

  get showBannerOnMobile() {
    if (this.queryParams?.hideNav === 'true') {
      return false;
    } else if (typeof this.formViewMetadata?.showBannerOnMobile !== 'undefined') {
      return this.formViewMetadata?.showBannerOnMobile;
    } else {
      return true;
    }
  }

  get customContactInfo() {
    return this.formViewMetadata?.customContactInfo;
  }

  constructor(
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private formViewService: FormViewService
  ) {}

  ngOnInit(): void {
    this.getCompanyById();
    this.formViewService.metadata
      .pipe(takeUntil(this.destroyed$))
      .subscribe((metadata) => {
        if (metadata && Object.keys(metadata)) {
          this.formViewMetadata = metadata;
        }
      });
  }

  getCompanyById() {
    this.companyService.companyDetails
      .pipe(
        first((company: Company) => (company?.id ? true : false)),
        takeUntil(this.destroyed$)
      )
      .subscribe((company: Company) => {
        this.companyDetails = company;
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }
}
